// Language definitions for Cartesia Sonic TTS
// Cartesia Sonic-3 supports 42 languages as of 2024
// Reference: https://docs.cartesia.ai/

export interface LanguageOption {
  code: string
  name: string
  localName: string // Local name in the native language
  flag: string // ISO 3166-1 alpha-2 country code for flag images
}

// Cartesia Sonic supported languages (42 total)
export const SONIC_LANGUAGES: LanguageOption[] = [
  { code: 'en', name: 'English', localName: 'English', flag: 'US' },
  { code: 'fr', name: 'French', localName: 'Français', flag: 'FR' },
  { code: 'de', name: 'German', localName: 'Deutsch', flag: 'DE' },
  { code: 'es', name: 'Spanish', localName: 'Español', flag: 'ES' },
  { code: 'pt', name: 'Portuguese', localName: 'Português', flag: 'PT' },
  { code: 'zh', name: 'Chinese', localName: '中文', flag: 'CN' },
  { code: 'ja', name: 'Japanese', localName: '日本語', flag: 'JP' },
  { code: 'hi', name: 'Hindi', localName: 'हिन्दी', flag: 'IN' },
  { code: 'it', name: 'Italian', localName: 'Italiano', flag: 'IT' },
  { code: 'ko', name: 'Korean', localName: '한국어', flag: 'KR' },
  { code: 'nl', name: 'Dutch', localName: 'Nederlands', flag: 'NL' },
  { code: 'pl', name: 'Polish', localName: 'Polski', flag: 'PL' },
  { code: 'ru', name: 'Russian', localName: 'Русский', flag: 'RU' },
  { code: 'sv', name: 'Swedish', localName: 'Svenska', flag: 'SE' },
  { code: 'tr', name: 'Turkish', localName: 'Türkçe', flag: 'TR' },
  { code: 'tl', name: 'Tagalog', localName: 'Tagalog', flag: 'PH' },
  { code: 'bg', name: 'Bulgarian', localName: 'Български', flag: 'BG' },
  { code: 'ro', name: 'Romanian', localName: 'Română', flag: 'RO' },
  { code: 'ar', name: 'Arabic', localName: 'العربية', flag: 'SA' },
  { code: 'cs', name: 'Czech', localName: 'Čeština', flag: 'CZ' },
  { code: 'el', name: 'Greek', localName: 'Ελληνικά', flag: 'GR' },
  { code: 'fi', name: 'Finnish', localName: 'Suomi', flag: 'FI' },
  { code: 'hr', name: 'Croatian', localName: 'Hrvatski', flag: 'HR' },
  { code: 'ms', name: 'Malay', localName: 'Bahasa Melayu', flag: 'MY' },
  { code: 'sk', name: 'Slovak', localName: 'Slovenčina', flag: 'SK' },
  { code: 'da', name: 'Danish', localName: 'Dansk', flag: 'DK' },
  { code: 'ta', name: 'Tamil', localName: 'தமிழ்', flag: 'IN' },
  { code: 'uk', name: 'Ukrainian', localName: 'Українська', flag: 'UA' },
  { code: 'hu', name: 'Hungarian', localName: 'Magyar', flag: 'HU' },
  { code: 'no', name: 'Norwegian', localName: 'Norsk', flag: 'NO' },
  { code: 'vi', name: 'Vietnamese', localName: 'Tiếng Việt', flag: 'VN' },
  { code: 'bn', name: 'Bengali', localName: 'বাংলা', flag: 'BD' },
  { code: 'th', name: 'Thai', localName: 'ไทย', flag: 'TH' },
  { code: 'he', name: 'Hebrew', localName: 'עברית', flag: 'IL' },
  { code: 'ka', name: 'Georgian', localName: 'ქართული', flag: 'GE' },
  { code: 'id', name: 'Indonesian', localName: 'Bahasa Indonesia', flag: 'ID' },
  { code: 'te', name: 'Telugu', localName: 'తెలుగు', flag: 'IN' },
  { code: 'gu', name: 'Gujarati', localName: 'ગુજરાતી', flag: 'IN' },
  { code: 'kn', name: 'Kannada', localName: 'ಕನ್ನಡ', flag: 'IN' },
  { code: 'ml', name: 'Malayalam', localName: 'മലയാളം', flag: 'IN' },
  { code: 'mr', name: 'Marathi', localName: 'मराठी', flag: 'IN' },
  { code: 'pa', name: 'Punjabi', localName: 'ਪੰਜਾਬੀ', flag: 'IN' },
]

// Helper function for finding a language by its code
export const findLanguageByCode = (code: string): LanguageOption | undefined => {
  return SONIC_LANGUAGES.find(lang => lang.code === code)
}
